import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { Store } from '@ngrx/store';
import {Observable} from 'rxjs';
import { PageNotificationService, AuthService, EventBusService, ShareDataService as SharedDataServiceGeneric } from '@signature-it/ngx-generic/services';
import { GenericConfig } from '@signature-it/ngx-generic/config';
import { EventName} from '@signature-it/ngx-generic/classes';
import { CartComponentGeneric } from '@signature-it/ngx-catalogue/pages/cart';
import { CartActions, CatalogueActions } from '@signature-it/ngx-catalogue/store/actions';
import { CartTotalQuantityDTO } from '@signature-it/ngx-catalogue/models';
import * as fromSelectors from '@signature-it/ngx-catalogue/store/selectors';
import { CartService } from '@signature-it/ngx-catalogue/services';
import { ProductPipe } from '@signature-it/ngx-catalogue/pipes';
import {PopoverDirective} from "ngx-bootstrap/popover";
import {trigger, state, style, animate, transition} from '@angular/animations';

declare let _;

const HEADER_CART_INDICATION_MODE = 'header';

@Component({
    selector: 'main-header-cart',
    animations: [trigger('openClose', [
            state('open', style({
                opacity: 1,
            })),
            state('closed', style({
                opacity: 0,
            })),
            transition('open => closed', [
                animate('1s')
            ]),
            transition('closed => open', [
                animate('1s')
            ]),
        ])],
    templateUrl: './cart.component.html',
    styleUrls: ['./cart.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MainHeaderCartComponentGeneric extends CartComponentGeneric implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild('cartPopover') cartPopover: PopoverDirective;
    data$: Observable<CartTotalQuantityDTO>;
    isMiniCart = false;

    isOpenCartModal = false;
    showCartIndication = false;
    cartIndicationText = '';
    cartIndicationSettings;
    cartLink = GenericConfig.orderType == "rfq" ? "/rfq" : "/cart";

    constructor(protected store$: Store<any>,

                protected notifySvc: PageNotificationService,
                protected cartSvc: CartService,
                protected productPipe: ProductPipe,
                protected authService: AuthService,
                protected eventBusService: EventBusService,
                protected shareDataGeneric: SharedDataServiceGeneric) {
        super(notifySvc, cartSvc, store$, productPipe, authService, shareDataGeneric);

        // const getCartAct = CartActions.getCart();
        //this.store$.dispatch(getCartAct);

        this.data$ = this.store$.select(fromSelectors.getCartItemsQuantity);

        this.isMiniCart = GenericConfig.miniCart;
        this.cartIndicationSettings = GenericConfig.cartIndication || {};
    }

    ngOnInit(): void {
        const getQuantityAct = CartActions.getItemsQuantity();
        this.store$.dispatch(getQuantityAct);
        if (this.isMiniCart) {
            super.ngOnInit();
        }
        this.cartIndicationText = this.cartIndicationSettings.text || 'The product has been added to your cart';
        this.eventBusService.on(EventName.HEADER_ADD_TO_CART_INDICATION, completed => {
            this.showAddToCart();
            this.closeModal();
        });
    }

    onSuccessLoad(data) {
        if (this.isMiniCart) {
            super.onSuccessLoad(data);
            if (!_.isEmpty(data)) {
                // update mini cart on every change
                this.store$.dispatch(CartActions.updateAllQuantities());
            }
        }
    }

    ngOnDestroy() {
        if (this.isMiniCart) {
            super.ngOnDestroy();
        }
    }

    onEditCart() {
        this.cartPopover.hide();
    }

    showAddToCart() {
        this.showCartIndication = true;
        this.isOpenCartModal = true;
        setTimeout(() => this.hideAddToCart(), this.cartIndicationSettings.fadeOutMiliSec || 3000);
    }

    hideAddToCart() {
        this.isOpenCartModal = false;
        setTimeout(() => this.showCartIndication = false, 1000);
    }

    closeModal() {
        const action = CartActions.addToCartCloseModal();
        this.store$.dispatch(action);
    }
}
